<template>
  <div class="report-detail-page container-block col-block">
    <div class="title-container">
      <div class="title">{{ report.title }}</div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="date-container">
      <span><b>發表時間：</b>{{ dateFormat(new Date(report.publish_time), 'yyyy/MM/dd hh:mm') }}</span>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="cover-container row-block">
      <div class="cover-block center-block">
        <img :src="(report.cover_photo || {}).url || require('../../assets/images/report-default-cover.jpeg')" alt="">
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="content-container ql-container ql-snow">
      <div class="content ql-editor" v-html="report.content || '沒有文字內容'"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="tag-container row-block">
      <div class="title">標籤：</div>
      <div class="tags row-block" :style="{ flex: 1 }">
        <div class="tag-field" v-for="(tag, tindex) in func.getReportTags(report)" :key="tindex">
          <div class="tag-block">
            <div class="tag-title" @click="e => setFilter(tag)">{{ tag.title + ',' }}</div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="report.external_link">
      <div :style="{ height: '10px' }"></div>
      <div class="link-container row-block">
        <div class="title">連結：</div>
        <div class="link" :style="{ flex: 1 }">
          <a class="link" :href="report.external_link" target="_blank">{{ report.external_link }}</a>
        </div>
      </div>
    </template>
    <template v-if="(report.attachments || []).length">
      <div :style="{ height: '10px' }"></div>
      <div class="attachment-container row-block">
        <div class="title">附件：</div>
        <div class="attachments col-block" :style="{ flex: 1, width: 0 }">
          <div class="attachment row-block" v-for="(attachment, tindex) in report.attachments" :key="tindex">
            <a v-if="rolePermission(['advance', 'admin'])" class="attachment-title link row-block" :href="attachment.url" target="_blank">
              <div class="name">{{ attachment.name }}</div>
              <div :style="{ width: '3px' }"></div>
              <div class="size">{{ '(' + convertFileSize(attachment.file_size) + ')' }}</div>
            </a>
            <div v-else class="attachment-title row-block">
              <div class="name">{{ attachment.name }}</div>
              <div :style="{ width: '3px' }"></div>
              <div class="size">{{ '(無權限下載)' }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </div>
      </div>
    </template>
    <div :style="{ height: '20px' }"></div>
    <template v-if="report.id">
      <comment
        :reportID="reportID"
      ></comment>
    </template>
    <div :style="{ flex: 1 }"></div>
  </div>
</template>

<script>
import { getReport } from '../../api'
import comment from './comment'
import routeLoading from '../../mixins/routeLoading'
import userPermission from '../../mixins/userPermission'
import { dateFormat, convertFileSize } from '../../constants/global/util'

export default {
  components: {
    comment
  },
  mixins: [
    routeLoading,
    userPermission
  ],
  props: {
    reportID: {
      type: Number,
      required: true
    },
    func: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      report: {}
    }
  },
  computed: {
    // global
    dateFormat () { return dateFormat },
    convertFileSize () { return convertFileSize }
  },
  watch: {
    'reportID' () {
      this.fetchData()
    }
  },
  methods: {
    async fetchData () {
      await this.fetchDatas()
    },
    async fetchDatas () {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.reportID
        let response = await getReport(id, config)
        let report = response.data.data
        this.report = report
      } catch (error) {
        throw error
      }
    },
    setFilter (tag) {
      this.$emit('setFilter', tag)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/detail.vue